import apiClient from 'services/axios'
import axios from 'axios'
import store from 'store'
import { firebaseAuth } from 'services/firebase'

const { REACT_APP_API_URL } = process.env

export async function login(username, password) {
  try {
    const response = await apiClient.post('/auth/local', {
      identifier: username,
      password,
    })

    if (response) {
      const { accessToken, jwt } = response.data
      if (accessToken && jwt) {
        store.set('accessToken', jwt)
        await firebaseAuth.signInWithCustomToken(accessToken)
      }
      return response.data
    }
    return false
  } catch (err) {
    console.log(err)
    return false
  }
}

export async function register(email, password, name) {
  return apiClient
    .post('/auth/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function currentAccount() {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebaseAuth.onAuthStateChanged(user => {
      unsubscribe()
      const getUserData = async () => {
        if (!user) return false
        const idToken = await firebaseAuth.currentUser
          .getIdToken(/* forceRefresh */ true)
          .then(token => {
            return token
          })
          .catch(err => {
            return err
          })
        const userData = await axios
          .get(`${REACT_APP_API_URL}/users/me`, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .then(response => {
            if (response) {
              return response.data
            }
            return false
          })
          .catch(err => console.log(err))
        return userData
      }

      resolve(getUserData())
    }, reject)
  })
}

export async function logout() {
  return firebaseAuth.signOut().then(() => {
    store.remove('accessToken')
    return true
  })
}

export async function getRegions() {
  try {
    const response = await apiClient.get('/region-names')

    if (response) {
      return response.data
    }
    return false
  } catch (err) {
    console.log(err)
    return false
  }
}
